export default __webpack_public_path__ + "static/ogg-Italic-57da5b46fc34cdc3a0762dc8bd13c552.woff";